import { AxiosResponse, isAxiosError } from 'axios';
import { default as createAxiosInstance } from '../middlewares/axios.interceptors';

const loginUrl = '/login';
const signUpUrl = '/cadastro';
const accountConfirmation = '/ativacao-conta';
const changePassword = '/redefinir-senha';
const validateCpf = '/verifica-cpf';

export const AuthService = {
  doLogin: async (data: { usuario: string; senha: string }) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(loginUrl, data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  signUp: async (data: any) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(signUpUrl, data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  accountConfirmation: async (token: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(`${accountConfirmation}`, { token });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  changePasswordValidateToken: async (token: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(`${changePassword}/${token}`);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  changePassword: async (data: { usuario: string; senha_atual: string; senha: string; confirmacao: string }) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(changePassword, data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  validateCpf: async (cpf: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(validateCpf, {
        params: {
          cpf
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  }
};
